import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {Stack, Button} from '@stubhub/bamboo';

import MESSAGES from '../messages';
import {BTN_TYPES} from '../utils/btnTypes';

import './CookieFooter.scss';

const CookieFooter = ({showConfigOptions, handleSubmit, handleShowConfigOptions}) => {
  return (
    <div className="CookieFooter__container">
      <Stack justify="end" spacing="md" direction="column" className="CookieFooter__cookieActionBtn">
        <Button size="md" onClick={() => handleSubmit(BTN_TYPES.ACCEPT_ALL)}>
          <FormattedMessage {...MESSAGES.ACCEPT_BTN} />
        </Button>
        <Button size="md" onClick={() => handleSubmit(BTN_TYPES.REJECT_ALL)}>
          <FormattedMessage {...MESSAGES.REJECT_BTN} />
        </Button>
      </Stack>
      <Stack justify="start" spacing="md" className="CookieFooter__cookieManagementBtn" direction="column">
        {showConfigOptions ? (
          <Button size="md" onClick={() => handleSubmit(BTN_TYPES.CUSTOM_COOKIES)}>
            <FormattedMessage {...MESSAGES.CONFIRM_BTN} />
          </Button>
        ) : (
          <Button size="md" appearance="tertiary" onClick={handleShowConfigOptions}>
            <FormattedMessage {...MESSAGES.MANAGEMENT_BTN} />
          </Button>
        )}
      </Stack>
    </div>
  );
};
CookieFooter.displayName = 'CookieModalFooter';

CookieFooter.propTypes = {
  /**
   * Bool true o false steps of content modal
   */
  showConfigOptions: PropTypes.bool,

  /**
   * Handle steps of content modal
   */
  handleShowConfigOptions: PropTypes.func,

  /**
   * Handle state of each cookies
   */
  handleSubmit: PropTypes.func,
};

export default CookieFooter;
